import type { Deck } from '../../types';
import Cover from './slides/01-cover';
import ThePitch from './slides/02-the-pitch';
import WhatIsAso from './slides/04-what-is-aso';
import TheProblem from './slides/05-the-problem';
import TheSolution from './slides/06-the-solution';
import TheProduct from './slides/07-the-product';
import TheCustomerWin from './slides/08-the-customer-win';
import TheCustomer from './slides/09-the-customer';
import WhyNow from './slides/10-why-now';
import CompetitiveLandscape from './slides/11-competitive-landscape';
import MoatTechEdge from './slides/12-moat-tech-edge';
import Validation from './slides/13-validation';
import FoundersWhyUs from './slides/14-founders-why-us';
import ASOMarket from './slides/15-aso-market';
import TheWiderPlay from './slides/16-the-wider-play';
import BusinessModelUnitEconomics from './slides/17-business-model-unit-economics';
import Roadmap from './slides/18-roadmap';
import TheRaise from './slides/19-the-raise';
import UseOfFunds from './slides/20-use-of-funds';
import CommonQuestions from './slides/A-common-questions';
import ToolConsolidation from './slides/B-tool-consolidation';
import CapitalEfficiency from './slides/C-capital-efficiency';
import Sources from './slides/D-sources';
import AiNativeFactory from './slides/E-ai-native-factory';

export const seriesSeedPrimerV5: Deck = {
  slug: 'series-seed-primer-v5',
  title: 'Apptonomy — Pre-Seed Primer',
  slides: [
    {
      id: 'cover',
      title: 'Cover',
      Component: Cover,
      sectionBefore: 'Intro',
    },
    {
      id: 'the-pitch',
      title: 'One-Pager',
      Component: ThePitch,
    },
    {
      id: 'what-is-aso',
      title: 'ASO',
      Component: WhatIsAso,
      sectionBefore: 'Product',
    },
    {
      id: 'the-problem',
      title: 'The Problem',
      Component: TheProblem,
    },
    {
      id: 'the-solution',
      title: 'The Solution',
      Component: TheSolution,
    },
    {
      id: 'the-product',
      title: 'The Platform',
      Component: TheProduct,
    },
    {
      id: 'the-customer-win',
      title: "Customer's Win",
      Component: TheCustomerWin,
    },
    {
      id: 'the-customer',
      title: 'The Customer',
      Component: TheCustomer,
      sectionBefore: 'Customer & Market',
    },
    { id: 'why-now', title: 'Why Now', Component: WhyNow },
    {
      id: 'competitive-landscape',
      title: 'Competitive Landscape',
      Component: CompetitiveLandscape,
    },
    {
      id: 'moat-tech-edge',
      title: 'Moat / Tech Edge',
      Component: MoatTechEdge,
    },
    {
      id: 'validation',
      title: 'Validation',
      Component: Validation,
    },
    {
      id: 'founders-why-us',
      title: 'Founders / Why Us',
      Component: FoundersWhyUs,
      sectionBefore: 'Business',
    },
    {
      id: 'aso-market',
      title: 'The ASO Market',
      Component: ASOMarket,
    },
    {
      id: 'the-wider-play',
      title: 'The Wider Play',
      Component: TheWiderPlay,
    },
    {
      id: 'business-model-unit-economics',
      title: 'Economics',
      Component: BusinessModelUnitEconomics,
    },
    { id: 'roadmap', title: 'Roadmap', Component: Roadmap },
    {
      id: 'the-raise',
      title: 'The Raise',
      Component: TheRaise,
    },
    {
      id: 'use-of-funds',
      title: 'Use of Funds',
      Component: UseOfFunds,
    },
    {
      id: 'common-questions',
      title: 'Common Questions',
      Component: CommonQuestions,
      sectionBefore: 'Appendices',
    },
    {
      id: 'tool-consolidation',
      title: 'Tool Consolidation',
      Component: ToolConsolidation,
    },
    {
      id: 'capital-efficiency',
      title: 'The AI Arbitrage',
      Component: CapitalEfficiency,
    },
    { id: 'sources', title: 'Sources', Component: Sources },
    {
      id: 'ai-native-factory',
      title: 'Agentic Software Factory',
      Component: AiNativeFactory,
    },
  ],
};
